module.exports = __webpack_public_path__ + "img/balcony.eb1f6833.png";